import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import router from '@/router'
const service = axios.create({
  baseURL:  process.env.VUE_APP_BASE_API,
  timeout: 15000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'RequestSource': 'SOURCE_MANASYS'
  }
})
// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.errCode == 50001) {
      router.push({path: '/login'})
      store.dispatch('LogOut')
  }
    if (res.success === true) {
      return response;
    } else {
      Message({
        message: res.errMsg || '请求失败',
        type: 'error',
        duration: 3 * 1000
      });
      return Promise.reject(new Error(res.errMsg || '请求失败'));
    }
  },
  error => {
    console.error('Response interceptor error:', error);
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    });
    return Promise.reject(error);
  }
)


// service.interceptors.response.use(
//   response => {
//   /**
//   * code为非200是抛错 可结合自己业务进行修改
//   */
//     const res = response.data
//     if (res.code !== 200) {
//       Message({
//         message: res.message,
//         type: 'error',
//         duration: 3 * 1000
//       })

//       // 401:未登录;
//       if (res.code === 401) {
//         MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
//           confirmButtonText: '重新登录',
//           cancelButtonText: '取消',
//           type: 'warning'
//         }).then(() => {
//           store.dispatch('FedLogOut').then(() => {
//             location.reload()// 为了重新实例化vue-router对象 避免bug
//           })
//         })
//       }
//       return Promise.reject('error')
//     } else {
//       return response.data
//     }
//   },
//   error => {
//     console.log('err' + error)// for debug
//     Message({
//       message: error.message,
//       type: 'error',
//       duration: 3 * 1000
//     })
//     return Promise.reject(error)
//   }
// )
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js